import React from 'react';

const IconScikitlearn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <circle cx="24" cy="24" r="22" fill="#F7931E" />
    <path
      fill="#FFF"
      d="M24 14c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 4c1.5 0 2.9.4 4.1 1.1L18.1 28c-.7-1.2-1.1-2.6-1.1-4 0-3.3 2.7-6 6-6zm0 12c-1.5 0-2.9-.4-4.1-1.1L29.9 20c.7 1.2 1.1 2.6 1.1 4 0 3.3-2.7 6-6 6z"
    />
  </svg>
);

export default IconScikitlearn;
